import h from 'hyperscript';

import { on } from 'cadenza/utils/event-util';
import { FlatpickrAbstractPlugin, isElementInRange } from 'cadenza/conditions/flatpickr-abstract-plugin';

const SHIFTS = {
  37: -1,
  39: 1,
  40: 5,
  38: -5
};
const PLUGIN_NAME = 'yearSelect';
const ELEMENTS_PER_PAGE = 25;
const ELEMENTS_CONTAINER_CLASS = 'd-flatpickr-years';
const ELEMENT_CLASS = 'd-flatpickr-year';
const ELEMENT_DISABLE_CLASS = 'flatpickr-disabled';

export class YearSelectPlugin extends FlatpickrAbstractPlugin {

  constructor () {
    super({ pluginName: PLUGIN_NAME, elementsPerPage: ELEMENTS_PER_PAGE, shifts: SHIFTS });
  }

  clearUnnecessaryDOMElements () {
    super.clearUnnecessaryDOMElements();
    this._fp.monthNav.querySelector('.flatpickr-current-month').remove();
  }

  addMonthNavEventListeners () {
    this._monthNavEventKeys = [
      on(this._fp.prevMonthNav, 'mousedown', event => {
        event.stopImmediatePropagation();
        this._currentPageFirstYear -= ELEMENTS_PER_PAGE; // We cannot use the this._fp.currentYear for navigation because it's set when choosing a date
        this.addElements();
        this.updateElementsStyle();
      }),
      on(this._fp.nextMonthNav, 'mousedown', event => {
        event.stopImmediatePropagation();
        this._currentPageFirstYear += ELEMENTS_PER_PAGE;
        this.addElements();
        this.updateElementsStyle();
      })
    ];
  }

  addElements () {
    if (!this._fp.rContainer) {
      return;
    }
    this.cleanElementsContainer(this._elementsContainer);
    if (!this._currentPageFirstYear) {
      this._setCurrentPageFirstYear();
    }
    this._elementsEventKeys = [];
    this._elements = [ ...Array(ELEMENTS_PER_PAGE).keys() ].map(yearIndex => {
      const year = this._currentPageFirstYear + yearIndex;
      const yearElement = h(`span.${ELEMENT_CLASS}`, {
        textContent: year,
        tabIndex: -1,
        '$i': yearIndex,
        dateObj: new Date(year, 0)
      });
      if (isElementInRange(yearElement.dateObj, this._fp.config.minDate, this._fp.config.maxDate)) {
        this._elementsEventKeys.push(
          on(yearElement, 'click', event => this.onClickElement(event)),
          on(yearElement, 'mouseover', event => this.onMouseoverElement(event))
        );
      } else {
        yearElement.classList.add(ELEMENT_DISABLE_CLASS);
      }
      return yearElement;
    });
    this._elementsContainer = h(`.${ELEMENTS_CONTAINER_CLASS}`, { tabIndex: -1 }, this._elements);
    this._fp.rContainer.appendChild(this._elementsContainer);
    this._currentlyFrom = this._elements[0].dateObj;
    this._currentlyTo = this._elements[ELEMENTS_PER_PAGE - 1].dateObj;
  }

  updateNavigationCurrentMonth () {
    this._fp._hidePrevMonthArrow = this._fp.config.minDate !== undefined && this._currentlyFrom.getFullYear() - 1 < this._fp.config.minDate.getFullYear();
    this._fp._hideNextMonthArrow = this._fp.config.maxDate !== undefined && this._currentlyTo.getFullYear() + 1 > this._fp.config.maxDate.getFullYear();
  }

  isOnCurrentPage (selectedDate) {
    return isElementInRange(selectedDate, this._currentlyFrom, this._currentlyTo);
  }

  resetElements () {
    this._setCurrentPageFirstYear();
    super.resetElements();
  }

  _setCurrentPageFirstYear () {
    this._currentPageFirstYear = Math.floor(this._fp.currentYear / ELEMENTS_PER_PAGE) * ELEMENTS_PER_PAGE;
  }

  _getClickedElement (selectedDate) {
    const currentlySelectedYear = selectedDate.getFullYear();
    return this._elements.find(element => element.dateObj.getFullYear() === currentlySelectedYear);
  }

}
